import { reportAuditSettlementsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_AUDIT_SETTLEMENTS_REPORT_FILTERS,
  RESTORE_INITIAL
} = reportAuditSettlementsTypes;

const getInitialState = () => ({
  startDate: newDate(),
  endDate: newDate(),
  station: null,
});

export const reportAuditSettlementsReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_AUDIT_SETTLEMENTS_REPORT_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
